import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Box from '../../shared/atoms/Box';
import Text from '../../shared/atoms/Text';

const Season = styled(Box)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  @media (min-width: ${(p) => p.theme.breakpoints.md}) {
    min-width: 120px;
    ::before {
      position: absolute;
      content: '';
      border-bottom: 6px solid ${(p) => p.theme.colors.gray.lighter};
      width: 100%;
      top: 17px;
      left: -50%;
      z-index: 0;
    }
    ::after {
      position: absolute;
      content: '';
      border-bottom: 2px solid ${(p) => p.theme.colors.gray.lighter};
      width: 100%;
      top: 17px;
      left: 50%;
      z-index: 0;
    }

    :first-child::before {
      content: none;
    }
    :last-child::after {
      content: none;
    }
  }

  ${(p) => p.isActive && 'color: black'};
`;
const Icon = styled(Box)`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
  z-index: 1;
  transition: transform 0.15s ease-out, opacity 0.15s ease-out;
  opacity: 0.6;
  ${(p) => p.isActive && 'transform: scale(1.08); opacity: 1;'};
  :hover {
    transform: scale(1.05);
    opacity: 1;
  }
`;

const Seasons = ({ season, setSeason, ...props }) => {
  const { t } = useTranslation();
  return (
    <Box flexDirection="row" justifyContent="space-between" {...props}>
      <Season mr={{ xs: 4, md: 0 }}>
        <Icon
          isActive={season === 'SPRING'}
          onClick={() => setSeason('SPRING')}>
          <img
            src="/static/img/photos/giftcard/season_small_spring.png"
            alt="Printemps - saison carte cadeau vélo"
            style={{
              width: 36,
              height: 40,
              objectFit: 'contain',
              cursor: 'pointer',
            }}
          />
        </Icon>
        <Text
          color={season === 'SPRING' ? 'black' : 'gray.darker'}
          fontWeight={2}
          fontSize={{ xs: 'xs', md: 'md' }}>
          {t('spring')}
        </Text>
      </Season>
      <Season mr={{ xs: 4, md: 0 }}>
        <Icon
          isActive={season === 'SUMMER'}
          onClick={() => setSeason('SUMMER')}>
          <img
            src="/static/img/photos/giftcard/season_small_summer.png"
            alt="Été - saison carte cadeau vélo"
            style={{
              width: 36,
              height: 40,
              objectFit: 'contain',
              cursor: 'pointer',
            }}
          />
        </Icon>
        <Text
          color={season === 'SUMMER' ? 'black' : 'gray.darker'}
          fontWeight={2}
          fontSize={{ xs: 'xs', md: 'md' }}>
          {t('summer')}
        </Text>
      </Season>
      <Season mr={{ xs: 4, md: 0 }}>
        <Icon
          isActive={season === 'AUTUMN'}
          onClick={() => setSeason('AUTUMN')}>
          <img
            src="/static/img/photos/giftcard/season_small_autumn.png"
            alt="Automne - saison carte cadeau vélo"
            style={{
              width: 36,
              height: 40,
              objectFit: 'contain',
              cursor: 'pointer',
            }}
          />
        </Icon>
        <Text
          color={season === 'AUTUMN' ? 'black' : 'gray.darker'}
          fontWeight={2}
          fontSize={{ xs: 'xs', md: 'md' }}>
          {t('autumn')}
        </Text>
      </Season>
      <Season>
        <Icon
          isActive={season === 'WINTER'}
          onClick={() => setSeason('WINTER')}>
          <img
            src="/static/img/photos/giftcard/season_small_winter.png"
            alt="Hiver - saison carte cadeau vélo"
            style={{
              width: 36,
              height: 40,
              objectFit: 'contain',
              cursor: 'pointer',
            }}
          />
        </Icon>
        <Text
          color={season === 'WINTER' ? 'black' : 'gray.darker'}
          fontWeight={2}
          fontSize={{ xs: 'xs', md: 'md' }}>
          {t('winter')}
        </Text>
      </Season>
    </Box>
  );
};
export default Seasons;
